import { render, staticRenderFns } from "./ProjectOverview.vue?vue&type=template&id=01382dc6&"
import script from "./ProjectOverview.vue?vue&type=script&lang=js&"
export * from "./ProjectOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports